import { ETypPrevodu } from 'services/specialniSluzby/uePozadavky';

import { ETypZpusobPredani } from 'enums/dokumentyEnums';

export const typPrevodu = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_BEZZAPLACENI',
        value: ETypPrevodu.BEZZAPLACENI
    },
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_PROTIZAPLACENI',
        value: ETypPrevodu.PROTIZAPLACENI
    }
];
export const typPrevoduPrikaz = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_PROTIZAPLACENI',
        value: ETypPrevodu.PROTIZAPLACENI
    }
];

export const typPrevoduNonDltExtra = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_PROTIABEZZAPL',
        value: ETypPrevodu.PROTIABEZZAPL
    }
];

export const zpusobPredaniDvpDefault = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MD',
        value: ETypZpusobPredani.MD
    },
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MDADMIN',
        value: ETypZpusobPredani.MDADMIN
    }
];

export const zpusobPredaniDvpNonDltExtra = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_PARSYST',
        value: ETypZpusobPredani.PARSYST
    }
];

export const zpusobPredaniDvpNonDltDluhopisExtra = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_BURZA',
        value: ETypZpusobPredani.BURZA
    }
];

export const zbusopPredaniDfp = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MD',
        value: ETypZpusobPredani.MD
    },
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MDADMIN',
        value: ETypZpusobPredani.MDADMIN
    }
];

export const zpusobPredaniDfpProtiExtra = [
    {
        labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_CDCP',
        value: ETypZpusobPredani.CDCP
    }
];
